import { Box, CardMedia } from '@mui/material';

import type { BasemapPreviewLayout } from './layersDrawer.shared';
import { useBasemapStyleSelectionStyles } from './layersDrawer.styles';

type BasemapStyleSelectionProps = {
  url: string;
  checked?: boolean;
  previewLayout?: BasemapPreviewLayout;
};

export const BasemapStyleSelection = (
  props: BasemapStyleSelectionProps,
): JSX.Element => {
  const { url, checked, previewLayout = 'square' } = props;
  const { classes, cx } = useBasemapStyleSelectionStyles({
    previewLayout,
  });

  return (
    <Box className={cx(classes.container, checked && classes.activeBackground)}>
      <CardMedia image={url} className={classes.media} component="div" />
    </Box>
  );
};
